import create, { SetState } from "zustand";

export type FeedbackDrawerStates = null | "requestFeedback" | "leaveFeedback";
export type RequestData = {
	requestId?: string;
	requestedBy?: {
		_id: string;
		name: string;
	};
	requestedTo?: {
		_id: string;
		name: string;
	};
	message?: string;
};

type FeedbackDrawerStoreState = {
	isOpen: boolean;
	requestData?: RequestData;
	feedbackId?: string;
	leaveFeedback: (state?: { requestData?: RequestData; feedbackId?: string }) => void;
	closeDrawer: () => void;
};

export const useFeedbackDrawerStore = create<FeedbackDrawerStoreState>((set: SetState<FeedbackDrawerStoreState>) => ({
	isOpen: false,
	setIsOpen: (isOpen: boolean) => set({ isOpen }),
	requestData: undefined,
	feedbackId: undefined,

	leaveFeedback: (state?: { requestData?: RequestData; feedbackId?: string }) => set({ isOpen: true, ...state }),
	closeDrawer: () => set({ isOpen: false, requestData: undefined, feedbackId: undefined }),
}));

type RequestFeedbackDrawerState = {
	isOpen: boolean;
	requestData?: RequestData;
	requestFeedback: (requestData?: RequestData) => void;
	closeDrawer: () => void;
};

export const useRequestFeedbackDrawerStore = create<RequestFeedbackDrawerState>(
	(set: SetState<RequestFeedbackDrawerState>) => ({
		isOpen: false,
		requestData: undefined,

		requestFeedback: (requestData?: RequestData) => set({ isOpen: true, requestData }),
		closeDrawer: () => set({ isOpen: false, requestData: undefined }),
	})
);

type FeedbackButtonsState = {
	forceHidden: boolean;
	setForceHidden: (hidden: boolean) => void;
};

export const useFeedbackButtonsStore = create<FeedbackButtonsState>((set: SetState<FeedbackButtonsState>) => ({
	forceHidden: false,
	setForceHidden: (hidden: boolean) => set({ forceHidden: hidden }),
}));
